const CLIENT_IP_STORAGE_KEY = 'client-ip-address';
const CLIENT_IP_ENDPOINT = 'https://api.ipify.org?format=json';
const CLIENT_IP_TIMEOUT_MS = 3000;

let cachedClientIp = '';
let hasResolvedClientIp = false;
let clientIpPromise;

const readStoredIp = () => {
	if (typeof window === 'undefined') return '';

	try {
		return sessionStorage.getItem(CLIENT_IP_STORAGE_KEY) || '';
	} catch (error) {
		return '';
	}
};

const storeIp = (ipAddress) => {
	if (typeof window === 'undefined' || !ipAddress) return;

	try {
		sessionStorage.setItem(CLIENT_IP_STORAGE_KEY, ipAddress);
	} catch (error) {}
};

export async function getClientIpAddress() {
	if (hasResolvedClientIp) return cachedClientIp;

	if (cachedClientIp) return cachedClientIp;

	const storedIp = readStoredIp();
	if (storedIp) {
		cachedClientIp = storedIp;
		hasResolvedClientIp = true;
		return storedIp;
	}

	if (!clientIpPromise) {
		clientIpPromise = (async () => {
			const controller = typeof AbortController !== 'undefined' ? new AbortController() : undefined;
			const timeoutId =
				controller && typeof globalThis?.setTimeout === 'function'
					? globalThis.setTimeout(() => controller.abort(), CLIENT_IP_TIMEOUT_MS)
					: undefined;

			try {
				const response = await fetch(CLIENT_IP_ENDPOINT, {
					method: 'GET',
					headers: {
						Accept: 'application/json',
					},
					...(controller ? { signal: controller.signal } : {}),
				});

				if (!response.ok) return '';

				const data = await response.json();
				const ipAddress = typeof data?.ip === 'string' ? data.ip.trim() : '';

				if (ipAddress) {
					cachedClientIp = ipAddress;
					storeIp(ipAddress);
				}

				return ipAddress;
			} catch (error) {
				return '';
			} finally {
				hasResolvedClientIp = true;
				if (typeof timeoutId !== 'undefined' && typeof globalThis?.clearTimeout === 'function') {
					globalThis.clearTimeout(timeoutId);
				}
			}
		})().finally(() => {
			clientIpPromise = undefined;
		});
	}

	return clientIpPromise;
}

export async function buildJsonHeaders(token) {
	const clientIpAddress = await getClientIpAddress();

	return {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		...(token?.session_key
			? {
					'sdk-authorization': `${token.session_key}`,
			  }
			: {}),
		...(clientIpAddress
			? {
					ip_address: clientIpAddress,
			  }
			: {}),
	};
}

export async function buildUploadHeaders(token) {
	const clientIpAddress = await getClientIpAddress();

	return {
		...(token?.session_key
			? {
					'sdk-authorization': `${token.session_key}`,
			  }
			: {}),
		...(clientIpAddress
			? {
					ip_address: clientIpAddress,
			  }
			: {}),
	};
}
